import React from 'react';
import { ClipboardListIcon, XIcon, CheckIcon } from 'lucide-react';
import { kitRows, kitChecklist } from '../data/comparisons';
export function KitControlSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="kit-title" data-id="element-141" data-mp="2x8cg4zq90aee">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-142" data-mp="2xa75cq8jyooa">
        <div className="max-w-2xl" data-id="element-143" data-mp="2s8hq0yearoue">
          <ClipboardListIcon className="h-8 w-8 text-sage-deep" aria-hidden="true" data-id="element-144" data-mp="2sbds8yx6gzon" />
          <h2 id="kit-title" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl" data-id="element-145" data-mp="2nbhlwt10cw5x">
            ¿Qué agrega el Kit Control Total?
          </h2>
          <p className="mt-4 text-lg text-body" data-id="element-146" data-mp="29irug92pmz1f">Para quienes quieren ir un paso más allá.</p>
        </div>

        <div className="mt-10 overflow-x-auto" data-id="element-147" data-mp="24jfb3yb1sa3l">
          <table className="w-full min-w-[46rem] border-collapse overflow-hidden rounded-2xl bg-white text-left" data-id="element-148" data-mp="24j5lwcxtu6yy">
            <thead data-id="element-149" data-mp="1zmow7eazbkjr">
              <tr className="bg-petrol text-white" data-id="element-150" data-mp="2q2zg5fdg4oi5">
                <th scope="col" className="px-6 py-4 font-display text-sm font-bold uppercase tracking-[0.1em]" data-id="element-151" data-mp="2q266a5j6xivs">
                  Situación real
                </th>
                <th scope="col" className="px-6 py-4 font-display text-sm font-bold uppercase tracking-[0.1em] text-white/70" data-id="element-152" data-mp="2h06ld2521unk">
                  Sin kit
                </th>
                <th scope="col" className="px-6 py-4 font-display text-sm font-bold uppercase tracking-[0.1em] text-cta" data-id="element-153" data-mp="3dsk1g4x2nxul">
                  Con Kit Control Total
                </th>
              </tr>
            </thead>
            <tbody data-id="element-154" data-mp="34tykge790qvx">
              {kitRows.map((row, index) => <tr key={row.situation} className={`border-t border-beige-deep ${index % 2 === 1 ? 'bg-cream' : 'bg-white'}`} data-id="element-155" data-mp="1ocua3o4ch99k" data-mpi={index}>
                  <th scope="row" className="px-6 py-5 align-top text-base font-semibold text-petrol" data-id="element-156" data-mp="19au5v20gdz03">
                    {row.situation}
                  </th>
                  <td className="px-6 py-5 align-top text-base text-body-muted" data-id="element-157" data-mp="15bd1yd0od9x1">
                    <span className="flex gap-2.5" data-id="element-158" data-mp="10gfqkzfxaogz">
                      <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-hover" aria-hidden="true" data-id="element-159" data-mp="vjz6cgbugu96" />
                      {row.without}
                    </span>
                  </td>
                  <td className="px-6 py-5 align-top text-base font-medium text-petrol" data-id="element-160" data-mp="ll9ouonv1btg">
                    <span className="flex gap-2.5" data-id="element-161" data-mp="hj4utoti2d6a">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-162" data-mp="hjy3wwfxlerl" />
                      {row.with}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 rounded-3xl border border-sage/30 bg-sage-soft px-6 py-8 sm:px-10" data-id="element-163" data-mp="26y2yri2saac4">
          <h3 className="font-display text-xl font-bold text-petrol sm:text-2xl" data-id="element-164" data-mp="2einad6p378q6">
            El Kit Control Total incluye:
          </h3>
          <ul className="mt-6 grid gap-x-10 gap-y-3.5 md:grid-cols-2" data-id="element-165" data-mp="2jf41m9rl237h">
            {kitChecklist.map(item => <li key={item} className="flex gap-3 text-base leading-relaxed text-body" data-id="element-166" data-mp="2oa16r5lqrsf3">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage-deep" aria-hidden="true" data-id="element-167" data-mp="2t8uiashgx9cm" />
                <span data-id="element-168" data-mp="1vl41c32mpq3r">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}